import { switchChain } from "@wagmi/core";
import { SELECTED_NETWORK_LOCAL_STORAGE_KEY } from "config/localStorage";
import { getRainbowKitConfig } from "./rainbowKitConfig";
import { ChainId } from "config/chains";

export type NetworkMetadata = {
  chainId: string;
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrls: string[];
  blockExplorerUrls: string[];
};


// BESC v2 chain entry in the v1 dropdown is a one-way migration shortcut —
// v1 has no BESC support; clicking it just hops the user to the new v2 site.
const BESC_V2_URL = "https://moneyxpro.com";

export async function switchNetwork(chainId: number, active: boolean): Promise<void> {
  if (chainId === 2372) { window.location.href = BESC_V2_URL; return; }
  if (active) {
    await switchChain(getRainbowKitConfig(), {
      chainId: chainId as ChainId,
    });
    localStorage.setItem(SELECTED_NETWORK_LOCAL_STORAGE_KEY, String(chainId));
  } else {
    // chainId in localStorage allows to switch network even if wallet is not connected
    // or there is no wallet at all
    localStorage.setItem(SELECTED_NETWORK_LOCAL_STORAGE_KEY, String(chainId));
    document.location.reload();
    return;
  }
}

export function shortenAddressOrEns(address: string, length: number) {
  if (!length) {
    return "";
  }
  if (!address) {
    return address;
  }
  if (address.length < 10 || address.length < length) {
    return address;
  }
  let left = address.includes(".") ? address.split(".")[1].length : Math.floor((length - 3) / 2) + 1;
  return address.substring(0, left) + "..." + address.substring(address.length - (length - (left + 3)), address.length);
}
